import { Building2, Factory, Landmark, Briefcase, TreePine, LineChart } from "lucide-react";
import { Reveal } from "../Reveal";
import { SectionHeading } from "./About";
import { BEST_FIT } from "../../lib/siteData";

const ICONS = [Building2, Factory, Landmark, Briefcase, TreePine, LineChart];

export const BestFit = () => {
  return (
    <section id="projects" data-testid="projects-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Best-Fit Projects"
            title="Built for complex, long-horizon infrastructure"
            subtitle="If your project fits any of the following, the consortium model is designed for you."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {BEST_FIT.map((project, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={i}
                delay={(i % 3) * 70}
                data-testid={`project-card-${i}`}
                className="group flex items-center gap-5 rounded-2xl border border-border bg-white p-6 transition-all hover:border-forest/30 hover:bg-forest-50"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-forest/15 bg-forest-50 transition-colors group-hover:bg-white">
                  <Icon className="text-forest" size={22} strokeWidth={1.8} />
                </div>
                <p className="font-body text-sm font-medium leading-snug text-forest">{project}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
